import { BrokerEngineVersion } from "@amzn/amazonmq-opsconsole-client";
import semver, { SemVer } from "semver";

export function getLatestPublicGAVersion(brokerEngineVersions: BrokerEngineVersion[]): string | undefined {
    // TODO: handle customized version for latest public_GA version
    let currentLatest : SemVer | undefined = undefined;    
    for (let i = 0; i < brokerEngineVersions.length; i++) {
        if (!(brokerEngineVersions[i].state === 'PUBLIC_GA')) {
            continue;
        }
        const coercedVersion = semver.coerce(brokerEngineVersions[i].version);
        if (!coercedVersion) {
            continue;
        }
        if (currentLatest === undefined || currentLatest.compare(coercedVersion) < 0) {
            currentLatest = coercedVersion;
        }
    }
    return currentLatest?.version;
}


export function isEarlierMinorVersion(brokerEngineVersion: string, latestEngineVersion: string): boolean {
    const brokerEngineSemVer = semver.coerce(brokerEngineVersion);
    const latestEngineSemVer = semver.coerce(latestEngineVersion);
    
    if (!brokerEngineSemVer || !latestEngineSemVer) {
        return false;
    }

    const brokerEngineVersionExcludingPatch = new SemVer(brokerEngineSemVer.major + "." + brokerEngineSemVer.minor + ".0");
    const latestEngineSemVerExcludingPatch = new SemVer(latestEngineSemVer.major + "." + latestEngineSemVer.minor + ".0");
    
    return brokerEngineVersionExcludingPatch.compare(latestEngineSemVerExcludingPatch) < 0;
}